module.exports = __webpack_public_path__ + "static/img/empty.213251e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/empty.png
// module id = +P+9
// module chunks = 76